export default {"src":"/_next/static/media/faq-icon.f463b4fe.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};